import { useState, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { PropagateLoader } from "react-spinners";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import "./subhistory.css";

dayjs.locale("ru");

const SubHistory = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [currencys, setCurrencys] = useState([
		"Monero",
		"Polkadot",
		"Tether",
		"Litecoin",
		"Binance",
		"Synthetix",
		"Unated State Dollar",
		"Bitcoin Cash",
		"Australian Dollar",
		"Solana",
		"Cosmos",
		"Chainlink",
		"Internet Computer",
	]);
	const [inputs, setInputs] = useState({
		currency: "",
		account: "",
		date: dayjs(),
	});

	useEffect(() => {
		const timer = setTimeout(() => setIsLoading(false), 2500);

		return () => clearTimeout(timer);
	}, []);

	// Обработчик изменения даты
	const handleChange = (e) => {
		setIsLoading(true);
		const { name, value } = e.target;
		setInputs({
			...inputs,
			[name]: value,
		});
		const timer = setTimeout(() => setIsLoading(false), 2500);

		return () => clearTimeout(timer); // Очистка таймера
	};
	return (
		<div className="subhistory">
			<div className="accounts-table-info">
				<div className="accounts-table-info-item">
					<div className="accounts-table-info-item-left">
						<p className="accounts-table-info-item-left-text">
							Фильтр истории погашения
						</p>
						<div className="subhistory-wrapper">
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									format="DD-MM-YYYY"
									value={inputs.date}
									name="date"
									onChange={handleChange}
									sx={{ width: "320px" }}
								/>
							</LocalizationProvider>
							<FormControl>
								<InputLabel id="currency-simple-select-label">Валюта</InputLabel>
								<Select
									labelId="currency-simple-select-label"
									id="currency-simple-select"
									value={inputs.currency}
									label="Валюта"
									sx={{ width: "320px" }}
									name="currency"
									onChange={handleChange}
								>
									<MenuItem value="">None</MenuItem>
									{currencys.map((currency, index) => (
										<MenuItem value={currency} key={index}>
											{currency}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl>
								<InputLabel id="account-simple-select-label">Аккаунт</InputLabel>
								<Select
									labelId="account-simple-select-label"
									id="account-simple-select"
									value={inputs.account}
									label="Аккаунт"
									sx={{ width: "320px" }}
									name="account"
									onChange={handleChange}
								>
									<MenuItem value="">None</MenuItem>
									<MenuItem value="Standart Аккаунт USD">Standart Аккаунт USD</MenuItem>
								</Select>
							</FormControl>
							<Button
								variant="contained"
								onClick={() => setInputs({ currency: "", account: "", date: dayjs() })}
							>
								Сброс
							</Button>
						</div>
					</div>
				</div>
				<div className="accounts-table-titles">
					<div className="accounts-table-titles-item">Сбережения</div>
					<div className="accounts-table-titles-item">Дата подписки</div>
					<div className="accounts-table-titles-item">Ставка</div>
					<div className="accounts-table-titles-item">Общий итог</div>
					<div className="accounts-table-titles-item">Дата погашения</div>
					<div className="accounts-table-titles-item">Перевод</div>
				</div>
				<div className="accounts-table-rows">
					{isLoading ? (
						<PropagateLoader color="#b7c4ff" />
					) : (
						<>
							<img src="/icons/cloud.svg" alt="empty-icon" />
							<p className="accounts-table-rows-empty">Не найдено погашений</p>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default SubHistory;
